import { useState, useEffect } from 'react';
import '../css/SyncQueueBadge.css';

function SyncQueueBadge() {
  const [queueLength, setQueueLength] = useState(0);

  useEffect(() => {
    const getQueueLength = async () => {
      if (!navigator.serviceWorker?.controller) return;

      try {
        const messageChannel = new MessageChannel();
        
        messageChannel.port1.onmessage = (event) => {
          if (event.data.type === 'QUEUE_LENGTH_RESPONSE') {
            setQueueLength(event.data.length);
          }
        };

        navigator.serviceWorker.controller.postMessage(
          { type: 'GET_QUEUE_LENGTH' },
          [messageChannel.port2]
        );
      } catch (error) {
        console.error('Error getting queue length:', error);
      }
    };

    // Listen for queue updates from service worker
    const handleServiceWorkerMessage = (event) => {
      if (event.data.type === 'QUEUE_UPDATED') {
        setQueueLength(event.data.length);
      }
    };

    getQueueLength();
    
    // Set up periodic updates every 2 seconds
    const interval = setInterval(getQueueLength, 2000);
    
    // Listen for messages from service worker
    navigator.serviceWorker?.addEventListener('message', handleServiceWorkerMessage);

    return () => {
      clearInterval(interval);
      navigator.serviceWorker?.removeEventListener('message', handleServiceWorkerMessage);
    };
  }, []);

  // Only render if there are queued requests
  if (queueLength === 0) return null;

  return (
    <div className="sync-badge-container">
      <span className="glyphicon glyphicon-send text-gray-600" style={{ fontSize: '18px' }} />
      <span className="sync-badge-count">
        {queueLength > 99 ? '99+' : queueLength}
      </span>
    </div>
  );
}

export default SyncQueueBadge;